<template>
  <div>

    <template
        v-if="showDropdownSelect">

      <a-select
          v-if="objectModelProperty.selection_type === PickListSelectionType.SingleSelect"
          :id="`entry_field_${propertyClientId}`"
          :options="dropdownOptions"
          :value="value && value[0]"
          :disabled="disabled"
          @input="toggleOption"
          bind-by-object
          force-nullify-if-null
          v-tooltip.wrap="tooltipIfDisabled"
          :class="commonEntriesPropertiesCssClasses"
      ></a-select>
      <template v-else>
        <a-select
            :id="$attrs.id"
            :options="dropdownOptions"
            :selectedOptionIds="value"
            bind-by-object
            :multiselect="true"
            compress
            @input="toggleMultiSelect"
           ></a-select>

        <template v-for="val in selectedValues">
          <pill
              @onRemove="toggleOption(val)"
              :value="val.label_title"
          ></pill>
        </template>
      </template>
    </template>

    <row v-else v-for="option of pickListOptions" :key="`option-${option.client_id}`">
      <column>
        <input
            :disabled="disabled"
            :type="inputType"
            :id="`option-${option.client_id}`"
            :checked="optionChecked(option)"
            v-tooltip.wrap.span="tooltipIfDisabled"
            :class="commonEntriesPropertiesCssClasses"
            @click="toggleOption(option)"
        />
        <label :for="`option-${option.client_id}`" class="d-inline">{{ option.labelTitleDisplay }}</label>
      </column>
    </row>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import objectModelEntryPropertiesMixin from "~/mixins/objectModelEntries/objectModelEntryPropertiesMixin";
import ObjectModelProperty from "../../../common/models/objectModelProperties/objectModelProperty";
import {PickListSelectionType} from "~/enums/pickListSelectionType";
import {IVOptionSetLocal} from "~/interfaces/vSelectInterfaces";

export default Vue.extend({
  mixins: [objectModelEntryPropertiesMixin],
  components: {},
  props: {
    value: Array as () => string[],
  },
  data: function () {
    return {PickListSelectionType};
  },
  computed: {
    showDropdownSelect() {
      if (this.isDetailViewEdit) {
        return (this.objectModelProperty.selection_type === PickListSelectionType.SingleSelect && this.pickListOptions.length > 2)
      } else {
        return this.objectModelProperty.selection_type === PickListSelectionType.SingleSelect && this.pickListOptions.length > 4
      }
    },
    pickListOptions(): ObjectModelProperty[] {
      const options = this.objectModelProperty.objectModelPropertiesArray;

      if (options.length > 4 && this.objectModelProperty.selection_type === PickListSelectionType.SingleSelect) {
        options.unshift({client_id: '', label_title: 'Select one...'});
      }

      return options
    },
    inputType(): string {
      switch (this.objectModelProperty.selection_type) {
        case PickListSelectionType.SingleSelect:
          return "radio";
        case PickListSelectionType.MultiSelect:
          return "checkbox";
      }
    },
    selectedValues(): Array<ObjectModelProperty>{
      return this.pickListOptions.filter(omp => this.value?.includes(omp.client_id))
    },
    dropdownOptions(): IVOptionSetLocal {
      return {
        valueKey: "client_id",
        labelKey: "label_title",
        options: this.pickListOptions
      };
    }
  },
  methods: {
    optionChecked(option: ObjectModelProperty): boolean {
      if (!this.value) return false;
      return this.value.includes(option.client_id);
    },
    toggleMultiSelect(val){
      const newValue = this.value ?  [...this.value] : [val];
      this.$emit("input", newValue);
    },
    toggleOption(option: ObjectModelProperty) {
      let newValue: string[]
      if (this.optionChecked(option)) {
        newValue = this.value.filter(it => it !== option.client_id);
      } else {
        if (!this.value || this.inputType === "radio") {
          newValue = [option.client_id];
        } else {
          newValue = [option.client_id, ...this.value];
        }
      }
      this.$emit("input", newValue);
    }
  }
});
</script>